
export default {
  person: {
    name:'zhangsan',
    hobby:'Singing and dancing, rap, basketball',
    登录:'login',
    密码:'Password',
    首页:'home',
    系统管理:'System Administration',
    菜单设置:'Menu settings',
    序号:'serial number',
    全部数据权限:'All data permissions',
    启用:'Enable',
    排序编码:'Sort code',
    角色名称:'Role name',
    机构级别:'Organization level',
    数据权限:'Data permissions',
    请选择组织架构:'Please select organization structure',
    新增:'Add',
    中心:'Center',
    用户账号:'User account',
    "详细地址 (英文)":'Detailed address (English)',
    中国:'China',
  },
};
